import MapView from '@arcgis/core/views/MapView';
import { useEffect, useState } from 'react';

const useMapView = ({
    map,
    container,
    ...rest
}: {
    map: any;
    container: HTMLDivElement;
}): MapView | undefined => {
    // Stops infinite render loop because state is only set once.
    // But does mean that view props cant be updated.
    const [data] = useState<any>({ ...rest });
    const [view, setView] = useState<MapView | undefined>();

    useEffect(() => {
        let v: MapView;
        const createMapView = async () => {
            if (container !== undefined && map !== undefined) {
                v = new MapView({ map, container, ...data });
                await v.when();
                setView(v);
            }
        };
        createMapView();
        return () => {
            v && v.destroy();
        };
    }, [container, map, data]);

    return view;
};

export default useMapView;
